import { FILE_ACCEPT } from '@fos/shared/contracts/knowledge';
import type { ComponentProps } from 'react';
import { cn } from '../lib/cn';
import { useFieldControl } from './Field';

/**
 * Pole wyboru pliku (natywne `<input type="file">` w wyglądzie przycisku Secondary). Czyta id, opis i błąd z `Field`.
 * Domyślnie lista dozwolonych typów z `FILE_ACCEPT` (serwer i tak sprawdza typ po treści).
 */
export function FilePickerInput({
  onFile,
  className,
  ...props
}: Omit<ComponentProps<'input'>, 'type' | 'onChange'> & { onFile: (file: File | null) => void }) {
  const field = useFieldControl(props);
  return (
    <input
      type="file"
      accept={FILE_ACCEPT}
      {...props}
      {...field}
      onChange={(e) => onFile(e.target.files?.[0] ?? null)}
      className={cn(
        'block w-full min-w-0 rounded-md text-body-s text-fg-secondary',
        'file:mr-3 file:h-8 file:cursor-pointer file:rounded-md file:border file:border-solid file:border-line',
        'file:bg-canvas file:px-3 file:text-label file:font-medium file:text-fg hover:file:bg-surface',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent',
        className,
      )}
    />
  );
}
